import { KdsCardFile, KdsText, VStack } from "@kazaar-platform/design-system";
import { useTranslate } from "@tolgee/react";
import { type DeliveryInformationsDispatchFileProps } from "./DeliveryInformationsDispatchFile.types";

export const DeliveryInformationsDispatchFile = ({
  orderItem,
}: DeliveryInformationsDispatchFileProps) => {
  const { t } = useTranslate();

  const dispatchFiles = orderItem.sandboxItem.dispatchFiles;

  return (
    <VStack gap="sp-sm">
      <KdsText size="subtitle-sm">
        {t(
          "order.catalogMediumConfiguration.stepDelivery.addressBlock.fileDispatch"
        )}
      </KdsText>

      {dispatchFiles?.map((dispatchFile) => (
        <KdsCardFile
          key={dispatchFile.blobId}
          fileName={dispatchFile.fileName}
          fileUrl={dispatchFile.url}
          fileSize={dispatchFile.size}
          isViewable
        />
      ))}
    </VStack>
  );
};
